import { TOP_10_TYPE_ENUM } from './enum'

export const ZK_PLATFORM_VALUE = {
  PORTER: 42,
  FARFETCH: 43,
  SSENSE: 44,
  SHOPBOP: 48,
  MUSINSA: 51,
  // MADA_IN_CHINA: 52,
  // MODA_OPERANDI: 53,
  // W_CONCEPT: 54,
  // ARCANA_ARCHIVE: 55,
  // LIEMEQUE: 56,
  // _8_DIVISION: 57,
  // LOHO_BRIDE: 58,
  // KHY: 59,
}

export const COMMON_PLATFORM_VALUE = {
  WHOLESALE: 7,
  RETAIL: 6,
  BRAND: 9,
  INS: 11,
  XIAOHONGSHU: 37,
  DW: 38,
  JP: 39,
  DHH: 40,
  INSGOODS: 41,
  PINTEREST: 50,
  WEIBO: 20,
  SHOW: 2,
  ITEM: 8,
  UPLOAD: 26,
  DY: 18,
  DY_WORKS: 19,
  DW_GOODS: 45,
  CROSSBORDER: 100,
  XIU_CHANGE_XI_JIE: 46,
  SHI_ZHUANG_DA_PIAN: 47,
  CROSSBORDER_INS: 97,
  CROSSBORDER_INS_GOODS: 98,
  CROSSBORDER_SHOW: 99,
  CROSSBORDER_PINTEREST: 96,
  CROSSBORDER_TIKTOK: 95,
  CROSSBORDER_PATTERN: 201,
  ZHI_XIAO_HONG: 49,
  TAOBAO_ZHI_DA: 571,
  COLLECT_PLUG: 27,
  FD_PLUS: 28,
  FD_MATERIAL: 29,
  ZXH_ITEM: 60,
}

export const PLATFORM_VALUE = {
  ...COMMON_PLATFORM_VALUE,
  ...ZK_PLATFORM_VALUE,
}

interface IPlatformConfigValue {
  label?: string
  value?: number | string
  dto?: string
  top10TypeOptions?: Array<{ label: string; value: TOP_10_TYPE_ENUM }>
  collectFrom?: string
}

export const ZK_DEFAULT_PLATFORM_CONFIG = { labelKey: '', fromData: (_, dto) => dto?.platformName, dto: 'standaloneSiteDataDTO' }
export const ZK_PLATFORM_CONFIG_ENUM = new Map<number | string, IPlatformConfigValue>([
  [ZK_PLATFORM_VALUE.PORTER, { label: 'NET-A-PORTER', value: ZK_PLATFORM_VALUE.PORTER, dto: 'porterDataDTO' }],
  [ZK_PLATFORM_VALUE.FARFETCH, { label: '发发奇', value: ZK_PLATFORM_VALUE.FARFETCH, dto: 'farfetchDataDTO' }],
  [ZK_PLATFORM_VALUE.SSENSE, { label: 'SSENSE', value: ZK_PLATFORM_VALUE.SSENSE, dto: 'ssenseDataDTO' }],
  [ZK_PLATFORM_VALUE.SHOPBOP, { label: 'shopbop', value: ZK_PLATFORM_VALUE.SHOPBOP, dto: 'shopbopDataDTO' }],
  [PLATFORM_VALUE.MUSINSA, { label: 'MUSINSA', value: PLATFORM_VALUE.MUSINSA, dto: 'musinsaDataDTO' }],
])

export const COMMON_PLATFORM_CONFIG_ENUM = new Map<number | string, IPlatformConfigValue>([
  [PLATFORM_VALUE.INS, { label: 'INS款式', value: PLATFORM_VALUE.INS, dto: 'insDataDTO', collectFrom: 'bloggerName' }],
  [PLATFORM_VALUE.BRAND, { label: '品牌预售', value: PLATFORM_VALUE.BRAND, dto: 'brandSelectedDataDTO' }],
  [PLATFORM_VALUE.WHOLESALE, { label: '批发市场', value: PLATFORM_VALUE.WHOLESALE, dto: 'wholesaleDataDTO' }],
  [PLATFORM_VALUE.RETAIL, { label: '零售市场', value: PLATFORM_VALUE.RETAIL, dto: 'retailDataDTO' }],
  [
    PLATFORM_VALUE.XIAOHONGSHU,
    { label: '小红书', value: PLATFORM_VALUE.XIAOHONGSHU, dto: 'xhsDataDTO', collectFrom: 'bloggerName' },
  ],
  [PLATFORM_VALUE.DW, { label: '得物', value: PLATFORM_VALUE.DW, dto: 'dewuDataDTO' }],
  [PLATFORM_VALUE.JP, { label: '街拍', value: PLATFORM_VALUE.JP, dto: 'streetSnapDataDTO' }],
  [PLATFORM_VALUE.DHH, { label: '订货会', value: PLATFORM_VALUE.DHH, dto: 'dhhDataDTO' }],
  [PLATFORM_VALUE.INSGOODS, { label: 'INS商品', value: PLATFORM_VALUE.INSGOODS, dto: 'insItemDataDTO' }],
  [PLATFORM_VALUE.PINTEREST, { label: 'Pinterest', value: PLATFORM_VALUE.PINTEREST, dto: 'pinterestDataDTO' }],
  [PLATFORM_VALUE.WEIBO, { label: '微博', value: PLATFORM_VALUE.WEIBO, dto: 'weiboDataDTO' }],
  [PLATFORM_VALUE.SHOW, { label: '秀场', value: PLATFORM_VALUE.SHOW, dto: 'runwayDataDTO' }],
  [
    PLATFORM_VALUE.ITEM,
    {
      label: '淘系',
      value: PLATFORM_VALUE.ITEM,
      dto: 'itemDataDTO',
      collectFrom: 'shopName',
      top10TypeOptions: [
        { label: '店铺', value: TOP_10_TYPE_ENUM.TAO_BAO_DIAN_PU },
        { label: '品牌', value: TOP_10_TYPE_ENUM.PIN_PAI },
      ],
    },
  ],
  [PLATFORM_VALUE.UPLOAD, { label: '上传灵感', value: PLATFORM_VALUE.UPLOAD, dto: 'userUploadDataDTO' }],
  [
    PLATFORM_VALUE.DY,
    {
      label: '抖衣',
      value: PLATFORM_VALUE.DY,
      dto: 'dyItemDataDTO',
      collectFrom: 'shopName',
      top10TypeOptions: [
        { label: '店铺', value: TOP_10_TYPE_ENUM.DY_DIAN_PU },
        { label: '品牌', value: TOP_10_TYPE_ENUM.PIN_PAI },
      ],
    },
  ],
  [
    PLATFORM_VALUE.DY_WORKS,
    { label: '抖衣作品', value: PLATFORM_VALUE.DY_WORKS, dto: 'dyVideoDataDTO', collectFrom: 'streamerName' },
  ],
  [PLATFORM_VALUE.DW_GOODS, { label: '得物商品', value: PLATFORM_VALUE.DW_GOODS, dto: 'dewuItemInfoDTO', collectFrom: 'brand' }],
  [PLATFORM_VALUE.XIU_CHANGE_XI_JIE, { label: '秀场细节', value: PLATFORM_VALUE.XIU_CHANGE_XI_JIE, dto: 'runwayDetailDataDTO' }],
  [
    PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN,
    { label: '时装大片', value: PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN, dto: 'fashionMasterpieceDataDTO' },
  ],
  [
    PLATFORM_VALUE.ZHI_XIAO_HONG,
    { label: '知小红', value: PLATFORM_VALUE.ZHI_XIAO_HONG, dto: 'zxhBlogDataDTO', collectFrom: 'nickname' },
  ],
  [
    PLATFORM_VALUE.ZXH_ITEM,
    { label: '知小红商品', value: PLATFORM_VALUE.ZXH_ITEM, dto: 'zxhItemDTO', collectFrom: 'shopInfo.shopName' },
  ],
  [
    PLATFORM_VALUE.CROSSBORDER,
    { label: '海外探款', value: PLATFORM_VALUE.CROSSBORDER, dto: 'crossBorderDTO', collectFrom: 'siteName' },
  ],
  [
    PLATFORM_VALUE.CROSSBORDER_INS_GOODS,
    { label: '海外探款-INS商品', value: PLATFORM_VALUE.CROSSBORDER_INS_GOODS, dto: 'insItemDataDTO' },
  ],
  [
    PLATFORM_VALUE.CROSSBORDER_INS,
    { label: '海外探款-INS款式', value: PLATFORM_VALUE.CROSSBORDER_INS, dto: 'insDataDTO', collectFrom: 'bloggerName' },
  ],
  [PLATFORM_VALUE.CROSSBORDER_SHOW, { label: '海外探款-秀场', value: PLATFORM_VALUE.CROSSBORDER_SHOW, dto: 'runwayDataDTO' }],
  [
    PLATFORM_VALUE.CROSSBORDER_PINTEREST,
    {
      label: '海外探款-Pinterest',
      value: PLATFORM_VALUE.CROSSBORDER_PINTEREST,
      dto: 'pinterestAbroadDataDTO',
      collectFrom: 'nickName',
    },
  ],
  [
    PLATFORM_VALUE.CROSSBORDER_TIKTOK,
    { label: '海外探款-Tiktok', value: PLATFORM_VALUE.CROSSBORDER_TIKTOK, dto: 'tiKTokAbroadDataDTO', collectFrom: 'userName' },
  ],
  [
    PLATFORM_VALUE.CROSSBORDER_PATTERN,
    { label: '海外探款-图案', value: PLATFORM_VALUE.CROSSBORDER_PATTERN, dto: 'patternAbroadDTO' },
  ],
  [PLATFORM_VALUE.TAOBAO_ZHI_DA, { label: '淘系搭配', value: PLATFORM_VALUE.TAOBAO_ZHI_DA, dto: 'zhiDaBlogDataDTO' }],
  [PLATFORM_VALUE.COLLECT_PLUG, { label: '采集插件', value: PLATFORM_VALUE.COLLECT_PLUG, dto: 'pluginUploadDataDTO' }],
  [PLATFORM_VALUE.FD_PLUS, { label: 'FD+智能设计', value: PLATFORM_VALUE.FD_PLUS, dto: 'fdPlusDataDTO' }],
  [PLATFORM_VALUE.FD_MATERIAL, { label: 'FD素材库', value: PLATFORM_VALUE.FD_MATERIAL, dto: 'fdMaterialDataDTO' }],
])

export const PLATFORM_CONFIG_ENUM = new Map<number | string, IPlatformConfigValue>([
  ...ZK_PLATFORM_CONFIG_ENUM,
  ...COMMON_PLATFORM_CONFIG_ENUM,
])

export const getDtoConfig = (platformId: string | number, isFromZkPlatform: boolean): IPlatformConfigValue => {
  if (isFromZkPlatform) {
    return ZK_PLATFORM_CONFIG_ENUM.get(Number(platformId)) || ZK_DEFAULT_PLATFORM_CONFIG
  }
  return COMMON_PLATFORM_CONFIG_ENUM.get(Number(platformId)) || {}
}

export const temuPlatformIds = [803, 4403, 4404, 4405, 4422, 4423, 4476, 4477, 4654, 4655, 4653]
export const amazonPlatformIds = [4, 5, 3787, 3788]
export const tiktokPlatformIds = [3869, 4374, 4375, 4544, 4651, 4652, 4650]
export const shopeePlatformIds = [4454, 4455, 4456]
export const mercadoLibrePlatformIds = [4756, 4757, 4758]
